<template>
  <refonte-card>
    <div class="w-full lg:h-full">
      <spinner
        v-if="loading"
        sizes="w-20 h-20"
        thickness="border-8" />
      <div v-if="!loading">
        <div class="mx-6 mb-2 mt-6">
          <div
            class="relative flex items-start overflow-hidden rounded-xl border border-primary-100 bg-primary-50 p-5 shadow-sm">
            <div
              class="mr-4 flex-shrink-0 rounded-lg bg-jinius-dark-green p-2 text-white shadow-sm">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round">
                <circle
                  cx="12"
                  cy="12"
                  r="10" />
                <path d="M12 16v-4" />
                <path d="M12 8h.01" />
              </svg>
            </div>
            <div class="flex-1">
              <h3 class="mb-1 text-sm font-bold">
                Guide de Signature Électronique
              </h3>
              <p class="text-slate-600 mb-4 max-w-2xl text-sm leading-relaxed">
                Pour vous accompagner dans la
                <strong>signature électronique de vos contrats</strong>, nous
                avons mis à votre disposition un guide pratique pour vous aider
                à finaliser vos documents en quelques clics.
              </p>
              <a
                v-bind:href="`${cdn_url}/aide-en-ligne/05032026_Formateurs - Guide-signature-elec.pdf`"
                target="_blank"
                class="inline-flex cursor-pointer items-center rounded-md bg-jinius-dark-green px-5 py-2 text-xs font-bold text-white shadow-md transition-all hover:scale-[1.02] active:scale-[0.98]">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="mr-2">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="7 10 12 15 17 10" />
                  <line
                    x1="12"
                    x2="12"
                    y1="15"
                    y2="3" />
                </svg>
                TÉLÉCHARGER LE GUIDE (PDF)
              </a>
            </div>
          </div>
        </div>
        <ag-grid-wrapper
          v-bind:column_defs="[
            {
              headerName: 'Période',
              field: 'periode',
              ...defaultColumnSettings
            },
            {
              headerName: 'Nature',
              field: 'typeContrat',
              ...defaultColumnSettings
            },
            {
              headerName: 'Type',
              field: 'perimetre',
              ...defaultColumnSettings
            },
            {
              headerName: 'Référence',
              field: 'contratReference',
              ...defaultColumnSettings
            },
            { headerName: 'Titre', field: 'titre', ...defaultColumnSettings },
            {
              headerName: 'Organisme',
              field: 'organisme',
              ...defaultColumnSettings
            },
            { headerName: 'Statut', field: 'statut', ...defaultColumnSettings },
            {
              headerName: 'Action',
              field: 'documents',
              cellRenderer: 'buttonCellRenderer',
              cellRendererParams: {
                label: 'Documents',
                labelDisabled: () => 'Non disponible',
                onclick: (e, params) => onOpenContratModal(e, params.data)
              }
            },
            {
              headerName: 'Société',
              field: 'societe',
              ...defaultColumnSettings
            },

            {
              headerName: 'Formation',
              field: 'formation',
              ...defaultColumnSettings
            },
            {
              headerName: 'Date',
              field: 'dateDebutString',
              ...defaultColumnSettings
            },
            { headerName: 'Lieu', field: 'lieu', ...defaultColumnSettings }
          ]"
          v-bind:initial_data="contrats" />
      </div>
      <contrat-modal
        v-bind:show_modal="showContratModal"
        v-bind:contrat="selectedContrat"
        v-bind:onclose="closeContratModal"
        v-bind:download_contrat="downloadContrat"
        v-bind:info_formateur="infosFormateur"
        contrat_base_url="formateur/contrats"
        v-bind:refresh_session="fetchContrats" />
    </div>
  </refonte-card>
</template>
<script>
  import AgGridWrapper from '@/components/utils/ag-grid/ag-grid-wrapper';
  import Spinner from '@/components/utils/spinner.vue';

  import { API } from '@/http-common';
  import ContratModal from '@/views/_espace/_refonte/formateur/_contrats/_modal/contrat-modal.vue';
  import http_functions from '@/mixin/http_functions';
  import RefonteCard from '@/components/refonte/cards/refonte-card.vue';
  import { map_domain_per_env } from '@/assets/data/data_maps.js';

  export default {
    components: {
      ContratModal,
      AgGridWrapper,
      Spinner,
      RefonteCard
    },
    mixins: [http_functions],
    data: () => ({
      loading: false,
      contrats: [],
      showContratModal: false,
      selectedContrat: null,
      infosFormateur: null
    }),
    computed: {
      cdn_url() {
        return `https://cdn.${
          map_domain_per_env[import.meta.env.VITE_CONTEXT]
        }`;
      },
      defaultColumnSettings() {
        return {
          filter: 'agTextColumnFilter',
          cellRenderer: 'textCenterCellRenderer',
          floatingFilter: true
        };
      }
    },
    created() {
      this.fetchContrats();
      this.fetchFormateurInfos();
    },
    methods: {
      async fetchContrats() {
        this.loading = true;
        const response = await API.get(
          'formateur/contrats',
          this.$header_skip_redirection
        );

        this.contrats = response.data;
        this.loading = false;
      },
      onOpenContratModal(e, selectedContrat) {
        this.selectedContrat = selectedContrat;
        this.showContratModal = true;
      },
      async fetchFormateurInfos() {
        const response = await API.get('formateur/signature/infos');
        if (response && response.data) {
          this.infosFormateur = response.data;
        }
      },
      closeContratModal() {
        this.selectedContrat = null;
        this.showContratModal = false;
      },
      async downloadContrat(id, type, nom) {
        await this.downloadFile(`formateur/contrats/${id}/file/${type}`, nom);
      }
    }
  };
</script>
<style lang="scss" scoped></style>
